import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-schedule-details',
    templateUrl: './schedule-details.component.html',
    styleUrls: ['./schedule-details.component.scss'],
    standalone: false
})
export class ScheduleDetailsComponent {

  details: any;
  date: string;
  time: string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.details = this.data.event;
    this.date = this.details?.title?.split(' | ')[1] + ' ' + this.details?.title?.split(' | ')[2]
    this.time = this.details?.title?.split(' | ')[3];
  }
}
